var lib_core = require("lib-core");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var SnapLockGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;

    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.holeDiameter = this.shadow("holeDiameter",
        function() {
            return self.data.holeDiameter() / self.getUnitFactor();
        },
        function(value) {
            return self.data.holeDiameter(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.holeDiameter, self.userSettingsModel.distanceUnit
        ]
    );

    this.boardThickness = this.shadow("boardThickness",
        function() {
            return self.data.boardThickness() / self.getUnitFactor();
        },
        function(value) {
            return self.data.boardThickness(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.boardThickness, self.userSettingsModel.distanceUnit
        ]
    );

    this.lockWidthOverride = this.shadow("lockWidthOverride",
        function() {
            return this.data.lockWidthOverride();
        },
        function(value) {
            return this.data.lockWidthOverride(value);
        },
        [this.data.lockWidthOverride]
    );

    this.lockWidth = this.shadow("lockWidth",
        function() {
            return self.data.lockWidth() / self.getUnitFactor();
        },
        function(value) {
            return self.data.lockWidth(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.lockWidth, self.userSettingsModel.distanceUnit
        ]
    );

    this.lockHeightMin = this.shadow("lockHeightMin",
        function() {
            return self.data.lockHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.lockHeightMin(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.lockHeightMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.lockHeightMax = this.shadow("lockHeightMax",
        function() {
            return self.data.lockHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.lockHeightMax(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.lockHeightMax, self.userSettingsModel.distanceUnit
        ]
    );
};

lib_core.inherit(SnapLockGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
SnapLockGeneratorInteractionModel.$class = 'SnapLockGeneratorInteractionModel';

module.exports = SnapLockGeneratorInteractionModel;

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForBodyHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('A', this.LCLZ('bodyHeight', 'Body Height'), true, null, false, this.bodyHeightMax, this.userSettingsModel.distanceUnit)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyDiameter', 'Body Diameter'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForLockHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('lockHeight', 'Lock Height'), false, this.lockHeightMin, false, this.lockHeightMax, this.userSettingsModel.distanceUnit)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForBoardThickness = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('A1', this.LCLZ('boardThickness', 'Board Thickness'), this.boardThickness, this.userSettingsModel.distanceUnit)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForHoleSize = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('b', this.LCLZ('holeDiameter', 'Hole Diameter'), this.holeDiameter, this.userSettingsModel.distanceUnit)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForOverridingLockWidth = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('overrideLockDiameter', 'Override Lock Diameter'), this.lockWidthOverride)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElementForLockWidth = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('E1', this.LCLZ('lockDiameter', 'Lock Diameter'), this.lockWidth, this.userSettingsModel.distanceUnit, this.lockWidthOverride)];
};

SnapLockGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('snapLockNote1', 
        '* Lock diameter (E1) is automatically calculated based on the body diameter (E) and hole diameter (b). However you can provide custom value by overriding the lock diameter.')));
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('snapLockNote2', 
        '* Hole diameter (b) should not be equal to the body diameter (E) and lock diameter(E1)')));
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());

    imElements = imElements.concat(this.getInspectorElementForLockHeight());
    imElements = imElements.concat(this.getInspectorElementForBoardThickness());

    imElements = imElements.concat(this.getInspectorElementForHoleSize());

    imElements = imElements.concat(this.getInspectorElementForOverridingLockWidth());
    imElements = imElements.concat(this.getInspectorElementForLockWidth());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
}; 